// extracted by mini-css-extract-plugin
module.exports = {"block":"info_block__26_kn","inner":"info_inner__3JDBM","card":"info_card__2POdx","border":"info_border__1lQK1","arrow":"info_arrow__dscCh","content":"info_content__1k9cD"};